module.exports = __webpack_public_path__ + "img/65D.4ff4f526.png";